var map = {
	"./00.png": 8896,
	"./01.png": 5145,
	"./02.png": 8562,
	"./03.png": 9067,
	"./04.png": 9156,
	"./05.png": 285,
	"./06.png": 2726,
	"./07.png": 4271
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 826;